import CustomDownloadChartButton from '@/components/Chart/ExportButton/CustomDownloadChartButton';
import ExportChartButton from '@/components/Chart/ExportButton/ExportChartButton';
import type { ChartType } from '@/components/Chart/types/highcharts';
import { CsvWidgetExportButton } from '@/components/CsvTableWidget/CsvWidgetExport/CsvWidgetExportButton';
import { canExportWidget } from '@/features/Dashboard/apps';
import type { FormAppWidget } from '@/features/Dashboard/apps/types';
import ExportWidgetButton from '@/pages/Markets/MarketsComponents/components/ExportWidgetButton';
import type { BaseTabType } from '@/types/markets';

export const isTabExportSupported = (tab: BaseTabType): boolean => {
  if (tab.type === 'graph' || tab.type === 'csvtable' || tab.type === 'minitable') {
    return true;
  }

  if (tab.type === 'spothistorytable') {
    return Boolean(tab.columns.length) && canExportWidget(tab as FormAppWidget);
  }

  return canExportWidget(tab as FormAppWidget);
};

const TabExportButton = ({ tab }: { tab: BaseTabType }) => {
  if (!isTabExportSupported(tab)) {
    return null;
  }

  if (tab.type === 'graph') {
    return tab.metadata?.graphType === 'custom' ? (
      <CustomDownloadChartButton
        metadata={tab.metadata}
        tabName={tab.name}
      />
    ) : (
      <ExportChartButton
        graphType={tab.metadata?.graphType as ChartType}
        metadata={tab.metadata}
        tabName={tab.name}
      />
    );
  }
  if (tab.type === 'csvtable') {
    return <CsvWidgetExportButton tabName={tab.name} />;
  }
  return <ExportWidgetButton tab={tab} />;
};

export default TabExportButton;
